export default {
    translation: {
        breadcrumbs: {
            '404': '404',
            '500': '500',
            'app': 'App',
            'horizontal': 'Horizontal',
            'horizontalMenu': 'Menu horizontal',
            'general': 'Général',
            'component': 'Composant',
            'features': 'Caractéristiques',
            'applications': 'Applications',
            'dashboard': 'tableau de bord',
            'dashboard1': 'Tableau de bord 1',
            'dashboard2': 'Tableau de bord 2',
            'dashboard3': 'Tableau de bord 3',
            'modules': 'Modules',
            'agency': 'Agence',
            'pages': 'Pages',
            'gallery': 'Galerie',
            'pricing': 'Tarification',
            'terms&Conditions': 'Termes et conditions',
            'feedback': 'Retour d\'information',
            'report': 'rapport',
            'faq(s)': 'Faq (s)',
            'advancedComponent': 'Composant avancé',
            'blank': 'Blanc',
            'session': 'Session',
            'login': 'S\'identifier',
            'register': 'Registre',
            'lockScreen': 'Écran verrouillé',
            'forgotPassword': 'Mot de passe oublié',
            'uiComponents': 'Composants de l\'interface utilisateur',
            'alerts': 'Alertes',
            'appBar': 'App Bar',
            'avatars': 'Avatars',
            'buttons': 'Boutons',
            'bottomNavigations': 'Navigation par le bas',
            'badges': 'Badges',
            'cards': 'Cartes',
            'cardsMasonry': 'Cartes Maçonnerie',
            'chip': 'Puce',
            'dialog': 'Dialogue',
            'dividers': 'Intercalaires',
            'drawers': 'Tiroirs',
            'popover': 'Popover',
            'expansionPanel': 'Panneau d\'extension',
            'gridList': 'Grille Liste',
            'list': 'liste',
            'menu': 'Menu',
            'popoverAndToolTip': 'Pop Over et pointe d\'outil',
            'progress': 'Le progrès',
            'snackbar': 'Snackbar',
            'selectionControls': 'Contrôles de sélection',
            'advanceUiComponents': 'Composants d\'interface utilisateur avancés',
            'dateAndTimePicker': 'Sélecteur de date et d\'heure',
            'tabs': 'onglets',
            'stepper': 'stepper',
            'notification': 'Notification',
            'sweetAlert': 'Alerte douce',
            'autoComplete': 'auto complet',
            'aboutUs': 'À propos de nous',
            'widgets': 'widgets',
            'forms': 'Formes',
            'formElements': 'Éléments de formulaire',
            'textField': 'Champ de texte',
            'selectList': 'Sélectionner la liste',
            'charts': 'Graphiques',
            'reCharts': 'Re Graphiques',
            'reactChartjs2': 'Réagir Chartjs 2',
            'icons': 'Icônes',
            'themifyIcons': 'Thémifier des icônes',
            'simpleLineIcons': 'Icônes de ligne simple',
            'fontAwesome': 'Police impressionnante',
            'materialIcons': 'Icônes de matériel',
            'tables': 'les tables',
            'basic': 'De base',
            'dataTable': 'Tableau de données',
            'responsive': 'Sensible',
            'reactTable': 'Réagir à la table',
            'maps': 'Des plans',
            'googleMaps': 'Google Plans',
            'leafletMaps': 'Cartes de brochures',
            'inbox': 'Boîte de réception',
            'users': 'Utilisateurs',
            'userProfile1': 'Profil de l\'utilisateur 1',
            'userProfile2': 'Profil d\'utilisateur 2',
            'userManagement': 'Gestion des utilisateurs',
            'userProfile': 'Profil de l\'utilisateur',
            'userList': 'liste d\'utilisateur',
            'calendar': 'Calendrier',
            'cultures': 'Des cultures',
            'dnd': 'Dnd',
            'selectable': 'Sélectionnable',
            'customRendering': 'Rendu personnalisé',
            'chat': 'Bavarder',
            'toDo': 'Faire',
            'editor': 'Éditeur',
            'wysiwygEditor': 'Éditeur WYSIWYG',
            'quillEditor': 'Éditeur de piquants',
            'reactAce': 'Réagir Ace',
            'dragAndDrop': 'Glisser déposer',
            'reactDragula': 'Réagir Dragula',
            'reactDnd': 'Réagir Dnd',
            'blogManagement': 'Gestion de blog',
            'ecommerce': 'Commerce électronique',
            'shopList': 'Liste de magasins',
            'shopGrid': 'Boutique Grid',
            'invoice': 'Facture d\'achat',
            'multilevel': 'multiniveau',
            'sublevel': 'sous-niveau',
            'dateTimePicker': 'Sélecteur de date et d\'heure',
            'user': 'Utilisateur',
            'miscellaneous': 'Divers',
            'promo': 'Promo',
            'gettingStarted': 'Commencer',
            'shop': 'Boutique',
            'cart': 'Chariot',
            'checkout': 'Check-out',
            'saas': 'SAAS',
            'multiLevel': 'MultiLevel',
            'level1': 'Niveau 1',
            'level2': 'Niveau 2',
            'boxed': 'En boîte',
            'news': 'Nouvelles',
            'extensions': 'Les extensions',
            'imageCropper': 'Cropper d\'image',
            'videoPlayer': 'Lecteur vidéo',
            'dropzone': 'Zone de largage',
            'crm': 'CRM',
            'projects': 'projets',
            'projectDetail': 'Détail du projet',
            'clients': 'les clients',
            'reports': 'rapports'
        },
        'widgets': {
            'totalEarns': 'total gagne',
            'emailsStatistics': 'Statistiques des emails',
            'totalRevenue': 'Revenu total',
            'onlineVistors': 'Visiteurs en ligne',
            'trafficSources': 'Sources de trafic',
            'RecentOrders': 'Dernières commandes',
            'topSellings': 'Meilleures ventes',
            'productReports': 'Rapports de produit',
            'productStats': 'Statistiques du produit',
            'ComposeEmail': 'Écrire un email',
            'employeePayroll': 'Employee Payroll',
            'visitors': 'Visiteurs',
            'orders': 'Ordres',
            'orderStatus': 'Statut de la commande',
            'totalSales': 'Ventes totales',
            'ratings': 'Évaluations',
            'netProfit': 'Bénéfice net',
            'overallTrafficStatus': 'État général du trafic',
            'tax': 'Impôt',
            'expenses': 'Expenses',
            'currentTime': 'Heure actuelle',
            'currentDate': 'Date actuelle',
            'todayOrders': 'Commandes d\'aujourd\'hui',
            'toDoList': 'Faire des listes',
            'discoverPeople': 'Découvrir les gens',
            'commments': 'commentaires',
            'newCustomers': 'nouveaux clients',
            'recentNotifications': 'Notifications récentes',
            'appNotifications': 'Notifications d\'application',
            'newEmails': 'Nouveaux emails',
            'siteVisitors': 'Visiteurs du site',
            'socialCompanines': 'Entreprises sociales',
            'recentActivities': 'Activités récentes',
            'recentOrders': 'Dernières commandes',
            'gallery': 'Galerie',
            'pricing': 'Tarification',
            'enterpriseEdition': 'Edition pour entreprise',
            'personalEdition': 'Édition personnelle',
            'teamEdition': 'Édition d\'équipe',
            'standard': 'la norme',
            'advanced': 'Avancée',
            'master': 'Maîtriser',
            'Mega': 'Mega',
            'logIn': 's\'identifier',
            'signUp': 'S\'inscrire',
            'lockScreen': 'Écran verrouillé',
            'alertsWithLink': 'Alertes avec lien',
            'additionalContent': 'Contenu additionnel',
            'alertDismiss': 'Refus d\'alerte',
            'uncontrolledDisableAlerts': 'Désactiver les alertes non contrôlées',
            'contexualAlerts': 'Alertes contextuelles',
            'alertsWithIcons': 'Alertes avec des icônes',
            'Simple App Bars': 'Barres d\'application simples',
            'appBarsWithButtons': 'Barres d\'applications avec boutons',
            'imageAvatars': 'Avatars d\'images',
            'lettersAvatars': 'Lettres Avatars',
            'iconsAvatars': 'Avatars d\'icônes',
            'flatButtons': 'Boutons plats',
            'raisedButton': 'Bouton surélevé',
            'buttonWithIconAndLabel': 'Bouton avec icône et étiquette',
            'floatingActionButtons': 'Boutons d\'action flottants',
            'iconButton': 'Bouton d\'icône',
            'socialMediaButton': 'Bouton Médias sociaux',
            'reactButton': 'Bouton Réagir',
            'buttonOutline': 'Contour du bouton',
            'buttonSize': 'Taille du bouton',
            'buttonState': 'Etat du bouton',
            'buttonNavigationWithNoLabel': 'bouton Navigation sans étiquette',
            'buttonNavigation': 'Bouton de navigation',
            'iconNavigation': 'Icône de navigation',
            'badgeWithHeadings': 'Badge avec des titres',
            'contexualVariations': 'Variations Contextuelles',
            'badgeLinks': 'Liens de Badge',
            'materialBadge': 'Badge de matériel',
            'simpleCards': 'Cartes simples',
            'backgroundVarient': 'Varient d\'arrière-plan',
            'cardOutline': 'Carte contour',
            'overlayCard': 'Carte de superposition',
            'cardGroup': 'Groupe de cartes',
            'cardTitle': 'Titre de la carte',
            'speacialTitleTreatment': 'Traitement du titre speacial',
            'chipWithClickEvent': 'Puce avec Click Click',
            'chipArray': 'Chip Array',
            'dialogs': 'Dialogues',
            'listDividers': 'List Diviseurs',
            'insetDividers': 'Intercalaires',
            'temporaryDrawers': 'Tiroirs temporaires',
            'permanentDrawers': 'Tiroirs permanents',
            'simpleExpansionPanel': 'Panneau d\'extension simple',
            'controlledAccordion': 'Accordéon contrôlé',
            'secondaryHeadingAndColumns': 'En-tête secondaire et colonnes',
            'imageOnlyGridLists': 'Listes de grille d\'images seulement',
            'advancedGridLists': 'Listes de grille avancées',
            'singleLineGridLists': 'Listes de grille unifilaires',
            'simpleLists': 'Listes simples',
            'folderLists': 'Listes de dossiers',
            'listItemWithImage': 'Elément de liste avec image',
            'switchLists': 'Commuter les listes',
            'insetLists': 'Listes d\'encart',
            'nestedLists': 'Listes imbriquées',
            'checkboxListControl': 'Contrôle de liste de cases à cocher',
            'pinedSubHeader': 'Sous-en-tête',
            'InteractiveLists': 'Listes interactives',
            'simpleMenus': 'Menus simples',
            'selectedMenu': 'Menu sélectionné',
            'maxHeightMenu': 'Max Height Menu',
            'changeTransition': 'Changer la transition',
            'paper': 'Papier',
            'anchorPlayGround': 'Terrain de jeu d\'ancre',
            'tooltip': 'Info-bulle',
            'positionedToolTips': 'Snackbar positionné',
            'circularProgressBottomStart': 'Progression circulaire Début inférieur',
            'interactiveIntegration': 'Intégration interactive',
            'determinate': 'Déterminé',
            'linearProgressLineBar': 'Barre de progression linéaire',
            'indeterminate': 'Indéterminé',
            'buffer': 'Tampon',
            'query': 'Question',
            'transitionControlDirection': 'Direction du contrôle de la transition',
            'simpleSnackbar': 'Snackbar simple',
            'positionedSnackbar': 'Snackbar positionné',
            'contexualColoredSnackbars': 'Snackbars colorés contexuels',
            'simpleCheckbox': 'Case à cocher simple',
            'interminateSelection': 'Sélection interminable',
            'disabledCheckbox': 'Case à cocher désactivée',
            'customColorCheckbox': 'Case à cocher de couleur personnalisée',
            'VerticalStyleCheckbox': 'Case à cocher Style vertical',
            'horizontalStyleCheckbox': 'Case à cocher Style horizontal',
            'radioButtons': 'Badges publicitaires',
            'disabledRadio': 'Radio désactivée',
            'withError': 'Avec erreur',
            'switches': 'Swiches',
            'dateAndTimePicker': 'Sélecteur de date et d\'heure',
            'defaultPicker': 'Sélection par défaut',
            'timePicker': 'Time Picker',
            'weekPicker': 'Sélecteur de semaine',
            'defaultDatePicker': 'Sélecteur de date par défaut',
            'customPicker': 'Sélecteur personnalisé',
            'tabs': 'Tabs',
            'fixedTabs': 'Onglets fixes',
            'basicTab': 'Onglet Basic',
            'wrappedLabels': 'Étiquettes enveloppées',
            'centeredLabels': 'Étiquettes centrées',
            'forcedScrolledButtons': 'Boutons défilants forcés',
            'iconsTabs': 'Onglets d\'icônes',
            'withDisableTabs': 'Avec les onglets Désactiver',
            'iconWithLabel': 'Icône avec étiquette',
            'stepper': 'Stepper',
            'horizontalLinear': 'Linéaire linéaire',
            'horizontalNonLinear': 'Horizontal non linéaire',
            'horizontalLinerAlternativeLabel': 'Étiquette alternative de doublure horizontale',
            'horizontalNonLinerAlternativeLabel': 'Étiquette alternative horizontale non doublure',
            'verticalStepper': 'Stepper vertical',
            'descriptionAlert': 'Description Alerte',
            'customIconAlert': 'Alerte d\'icône personnalisée',
            'withHtmlAlert': 'avec Html Alert',
            'promptAlert': 'Alerte rapide',
            'passwordPromptAlert': 'Alerte de mot de passe',
            'customStyleAlert': 'Alerte de style personnalisé',
            'autoComplete': 'Auto complet',
            'reactSelect': 'React Select',
            'downshiftAutoComplete': 'Réacheminement automatique terminé',
            'reactAutoSuggests': 'Réagissez Auto Suggests',
            'aboutUs': 'À propos de nous',
            'ourVission': 'Notre vision',
            'ourMissions': 'Nos missions',
            'ourMotivation': 'Notre motivation',
            'defualtReactForm': 'Defualt React Form',
            'url': 'Url',
            'textArea': 'Zone de texte',
            'file': 'Fichier',
            'formGrid': 'Grille de formulaire',
            'inlineForm': 'Formulaire en ligne',
            'inputSizing': 'Dimensionnement d\'entrée',
            'inputGridSizing': 'Dimensionnement de la grille d\'entrée',
            'hiddenLabels': 'Étiquettes cachées',
            'formValidation': 'Validation de formulaire',
            'number': 'Nombre',
            'date': 'Rendez-vous amoureux',
            'time': 'Temps',
            'color': 'Couleur',
            'search': 'Chercher',
            'selectMultiple': 'Sélectionnez plusieurs',
            'inputWithSuccess': 'Entrer avec succès',
            'inputWithDanger': 'Entrée avec danger',
            'simpleTextField': 'Champ de texte simple',
            'componet': 'Composants',
            'layouts': 'Layouts',
            'inputAdorements': 'Adorations d\'entrée',
            'formattedInputs': 'Entrées formatées',
            'simpleSelect': 'Simple Select',
            'nativeSelect': 'Sélection native',
            'MutltiSelectList': 'Liste de sélection Mutlti',
            'lineChart': 'Graphique en ligne',
            'barChart': 'Diagramme à bandes',
            'stackedBarChart': 'Graphique à barres empilées',
            'lineBarAreaChart': 'Graphique de la barre de ligne',
            'areaChart': 'Graphique de zone',
            'stackedAreaChart': 'Graphique de zone empilée',
            'verticalChart': 'Graphique vertical',
            'radarChart': 'Graphique radar',
            'doughnut': 'Beignet',
            'polarChart': 'Graphique polaire',
            'pieChart': 'Camembert',
            'bubbleChart': 'Graphique à bulles',
            'horizontalBar': 'Barre horizontale',
            'basicTable': 'Table de base',
            'contexualColoredTable': 'Table colorée contexuelle',
            'dataTable': 'Tableau de données',
            'employeeList': 'Liste des employés',
            'responsiveTable': 'Responsive Table',
            'responsiveFlipTable': 'Table à bascule souple',
            'reactGridControlledStateMode': 'Réagir le mode d\'état contrôlé par la grille',
            'googleMaps': 'Google Maps',
            'productsReports': 'Rapports de produits',
            'taskList': 'Liste de tâches',
            'basicCalender': 'Calendrier basique',
            'culturesCalender': 'Cultures Calendrier',
            'dragAndDropCalender': 'Drag and Drop Calender',
            'selectableCalender': 'Calendrier sélectionnable',
            'customRendering': 'Rendu personnalisé',
            'customCalender': 'Calendrier personnalisé',
            'searchMailList': 'Rechercher une liste de courrier',
            'forgetPassword': 'Mot de passe oublié',
            'QuickLinks': 'Liens rapides',
            'upgrade': 'améliorer',
            'app': 'App',
            'addNew': 'Ajouter un nouveau',
            'orderDate': 'Date de commande',
            'status': 'Statut',
            'trackingNumber': 'Numéro de suivi',
            'action': 'action',
            'designation': 'La désignation',
            'subject': 'assujettir',
            'send': 'Envoyer',
            'saveAsDrafts': 'Enregistrer en tant que brouillons',
            'onlineSources': 'Sources en ligne',
            'lastMonth': 'Le mois dernier',
            'widgets': 'Widgets',
            'listing': 'Inscription',
            'paid': 'Payé',
            'refunded': 'Remboursé',
            'done': 'Terminé',
            'pending': 'en attendant',
            'cancelled': 'Annulé',
            'approve': 'Approuver',
            'following': 'Suivant',
            'follow': 'suivre',
            'graphs&Charts': 'Graphiques et graphiques',
            'open': 'Ouvrir',
            'bounced': 'Rebondi',
            'spam': 'Spam',
            'unset': 'Annuler',
            'bandwidthUse': 'Utilisation de la bande passante',
            'dataUse': 'Utilisation de données',
            'unsubscribe': 'Se désabonner',
            'profile': 'Profil',
            'messages': 'messages',
            'support': 'Soutien',
            'faq(s)': 'Faq (s)',
            'upgradePlains': 'Mettre à niveau les plaines',
            'logOut': 'Connectez - Out',
            'mail': 'Courrier',
            'adminTheme': 'Thème Admin',
            'wordpressTheme': 'Thème Wordpress',
            'addToCart': 'Ajouter au panier',
            'plan': 'Plan',
            'basic': 'De base',
            'pro': 'Pro',
            'startToBasic': 'Début à la base',
            'upgradeToPro': 'Passer à Pro',
            'upgradeToAdvance': 'Mettre à niveau à l\'avance',
            'comparePlans': 'Comparer les plans',
            'free': 'Gratuit',
            'frequentlyAskedQuestions': 'Questions fréquemment posées',
            'searchIdeas': 'Rechercher des idées',
            'startDate': 'Date de début',
            'endDate': 'Date de fin',
            'category': 'Catégorie',
            'apply': 'Appliquer',
            'downloadPdfReport': 'Télécharger le rapport Pdf',
            'yesterday': 'Hier',
            'totalOrders': 'Total des commandes',
            'totalVisitors': 'Nombre total de visiteurs',
            'typeYourQuestions': 'Tapez vos questions',
            'username': 'Nom d\'utilisateur',
            'password': 'Mot de passe',
            'signIn': 'Se connecter',
            'enterYourPassword': 'Tapez votre mot de passe',
            'alreadyHavingAccountLogin': 'Vous avez déjà un identifiant de compte',
            'composeMail': 'Écrire un email',
            'issue': 'Problème',
            'recentChat': 'Chat récent',
            'previousChat': 'Chat précédent',
            'all': 'Tout',
            'filters': 'Filtres',
            'deleted': 'Supprimé',
            'starred': 'Marqué',
            'frontend': 'L\'extrémité avant',
            'backend': 'Backend',
            'api': 'Api',
            'simpleAppBar': 'Barre d\'application simple',
            'recents': 'Récents',
            'cardLink': 'Lien de carte',
            'anotherLink': 'Un autre lien',
            'cardSubtitle': 'Sous-titre de la carte',
            'confirmationDialogs': 'Dialogues de confirmation',
            'deletableChip': 'Puce Deletable',
            'customDeleteIconChip': 'Chip d\'icône de suppression personnalisée',
            'openAlertDialog': 'Ouvrir la boîte de dialogue d\'alerte',
            'openResponsiveDialog': 'Ouvrir le dialogue réactif',
            'openSimpleDialog': 'Ouvrir une boîte de dialogue simple',
            'openFormDialog': 'Ouvrir la boîte de dialogue de formulaire',
            'follower': 'Disciple',
            'important': 'Important',
            'private': 'Privé',
            'openLeft': 'Ouvrir à gauche',
            'openRight': 'Ouvert à droite',
            'openTop': 'Toit ouvert',
            'openBottom': 'Fond ouvert',
            'selectTripDestination': 'Sélectionnez la destination du voyage',
            'pinnedSubheaderList': 'Liste de sous-titres épinglés',
            'singleLineItem': 'Élément de ligne unique',
            'acceptTerms': 'Accepter les termes',
            'optionA': 'Option A',
            'optionB': 'Option B',
            'optionC': 'Option C',
            'optionM': 'Option M',
            'optionN': 'Option N',
            'optionO': 'Option O',
            'customColor': 'Couleur personnalisée',
            'centeredTabs': 'Onglets centrés',
            'multipleTabs': 'Onglets multiples',
            'preventScrolledButtons': 'Empêcher les boutons défilés',
            'browse': 'Feuilleter',
            'formValidate': 'Formulaire de validation',
            'code': 'Code',
            'company': 'Compagnie',
            'price': 'Prix',
            'change': 'Changement',
            'high': 'Haute',
            'low': 'Faible',
            'volume': 'Le volume',
            'personalDetails': 'Détails personnels',
            'occupation': 'Occupation',
            'companyName': 'Nom de la compagnie',
            'phoneNo': 'Pas de téléphone',
            'city': 'Ville',
            'zipCode': 'Code postal',
            'updateProfile': 'Mettre à jour le profil',
            'reject': 'Rejeter',
            'exportToExcel': 'Exporter vers Excel',
            'addNewUser': 'Ajouter un nouvel utilisateur',
            'workWeek': 'Semaine de travail',
            'agenda': 'Ordre du jour',
            'conference': 'Conférence',
            'multilevel': 'Multilevel',
            'dailySales': 'Ventes quotidiennes',
            'today': 'Aujourd\'hui',
            'campaignPerformance': 'Performance de la campagne',
            'supportRequest': 'Demande de soutien',
            'usersList': 'Liste des utilisateurs',
            'lastWeek': 'La semaine dernière',
            'buyMore': 'Acheter plus',
            'trafficChannel': 'Canal de trafic',
            'stockExchange': 'Bourse',
            'tweets': 'Tweets',
            'ourLocations': 'Nos sites',
            'sales': 'Ventes',
            'to': 'Pour',
            'shipTo': 'Expédier à',
            'description': 'Description',
            'unitPrice': 'Prix unitaire',
            'total': 'total',
            'note': 'Remarque',
            'chipWithAvatar': 'Puce avec Avatar',
            'chipWithTextAvatar': 'Chip avec l\'avatar de texte',
            'chipWithIconAvatar': 'Puce avec icône Avatar',
            'customClickableChip': 'Puce cliquable personnalisée',
            'outlineChip': 'Puce de contour',
            'disableChip': 'Désactiver la puce',
            'alertDialog': 'Dialogue d\'alerte',
            'animatedSlideDialogs': 'Dialogues de diapositives animées',
            'fullScreenDialogs': 'Dialogue plein écran',
            'formDialogs': 'Form Dialogues',
            'simpleDialogs': 'Dialogues simples',
            'responsiveFullScreen': 'Plein écran réactif',
            'primary': 'Primaire',
            'social': 'Social',
            'user': 'Utilisateur',
            'admin': 'Admin',
            'permanentdrawer': 'Tiroir permanent',
            'persistentdrawer': 'Tiroir persistant',
            'swiches': 'Swiches',
            'horizontalLinearAlternativeLabel': 'Étiquette alternative linéaire horizontale',
            'horizontalNonLinearAlternativeLabel': 'Étiquette alternative non linéaire horizontale',
            'notifications': 'Notifications',
            'basicAlert': 'Alerte de base',
            'AcceptorrRejectWithin': 'Accepter ou rejeter dans',
            'quoteOfTheDay': 'Citation du jour',
            'updated10Minago': 'Mis à jour il y a 10 minutes',
            'personalSchedule': 'Horaire personnel',
            'activeUsers': 'Utilisateurs actifs',
            'totalRequest': 'Demande totale',
            'new': 'Nouveau',
            'ShareWithFriends': 'Partager avec des amis!',
            'helpToShareText': 'Aidez-nous à propager le monde en partageant notre site avec vos amis et adeptes sur les réseaux sociaux!',
            'thisWeek': 'Cette semaine',
            'howWouldYouRateUs': 'Comment nous évalueriez-vous?',
            'booking': 'Réservation',
            'confirmed': 'Confirmé',
            'monthly': 'Mensuel',
            'weekly': 'hebdomadaire',
            'target': 'Target',
            'totalActiveUsers': 'Total des utilisateurs actifs',
            'deadline': 'Date limite',
            'team': 'Équipe',
            'projectManagement': 'Gestion de projet',
            'latestPost': 'Dernier message',
            'projectTaskManagement': 'Gestion des tâches de projet',
            'selectProject': 'Sélectionner un projet',
            'activityBoard': 'Conseil d\'activité',
            'checklist': 'Liste de contrôle',
            'baseConfig': 'Base Config',
            'customControlBar': 'Barre de contrôle personnalisée',
            'withDownloadButton': 'Avec bouton de téléchargement',
            'httpLiveStreaming': 'HTTP Live Streaming',
            'keyboardShortcuts': 'Raccourcis clavier',
            'preview': 'Aperçu',
            'croppedImage': 'Image recadrée',
            'transactionList': 'liste de transaction',
            'transferReport': 'rapport de transfert',
            'expenseCategory': 'catégorie de dépense',
            'upcomingEvents': 'évènements à venir',
            'OngoingProjects': 'projets en cours',
            'ProjectStatus': 'l\'état du projet',
            'LiveChatSupport': 'support de chat en direct'
        },
        'components': {
            'buyNow': 'Acheter maintenant',
            'alreadyHavingAccountSignIn': 'Vous avez déjà un compte Connexion',
            'enterYourPassword': 'Tapez votre mot de passe',
            'unlock': 'Ouvrir',
            'enterPasswords': 'Entrer les mots de passe',
            'resetPassword': 'réinitialiser le mot de passe',
            'pageNotfound': 'Page non trouvée',
            'goToHomePage': 'Aller à la page d\'accueil',
            'sorryServerGoesWrong': 'Désolé, le serveur va mal',
            'persistentDrawer': 'Tiroir persistant',
            'back': 'Arrière',
            'next': 'Prochain',
            'completeStep': 'Étape complète',
            'withHtml': 'Avec Html',
            'prompt': 'Rapide',
            'withDescription': 'Avec description',
            'success': 'Succès',
            'passwordPrompt': 'Invite de mot de passe',
            'warning': 'Attention',
            'customIcon': 'Icône personnalisée',
            'customStyle': 'Style personnalisé',
            'basic': 'De base',
            'submit': 'Soumettre',
            'compose': 'Composer',
            'sendMessage': 'Envoyer le message',
            'addNewTasks': 'Ajouter de nouvelles tâches',
            'addToCart': 'Ajouter au panier',
            'payNow': 'Payez maintenant',
            'print': 'Impression',
            'cart': 'Chariot',
            'viewCart': 'Voir le panier',
            'checkout': 'Check-out',
            'summary': 'Résumé',
            'yesterday': 'Hier',
            'last7Days': 'Les 7 derniers jours',
            'last1Month': 'Le dernier mois',
            'last6Month': 'Les 6 derniers mois',
            'spaceUsed': 'Espace utilisé',
            'followers': 'disciple',
            'trending': 'Tendance',
            'paid': 'Payé',
            'refunded': 'Remboursé',
            'done': 'Terminé',
            'pending': 'En attente',
            'cancelled': 'Annulé',
            'approve': 'Approuver',
            'week': 'Semaine',
            'month': 'Month',
            'year': 'Année',
            'today': 'Aujourd\'hui',
            'popularity': 'Popularité',
            'email': 'Email',
            'drafts': 'brouillons',
            'sent': 'Envoyé',
            'trash': 'Corbeille',
            'all': 'Tous',
            'do': 'faire',
            'title': 'Titre',
            'projectName': 'Nom du projet',
            'companyName': 'Nom de l\'entreprise',
            'openAlert': 'Ouvrir l\'alerte',
            'slideInAlertDialog': 'Diapositive dans la boîte de dialogue d\'alerte',
            'openFullScreenDialog': 'Ouvrir les dialogues plein écran',
            'basicChip': 'Puce de base',
            'clickableChip': 'Cliquable',
            'left': 'Gauche',
            'right': 'Droit',
            'expansionPanel1': 'Panneau d\'extension 1',
            'expansionPanel2': 'Panneau d\'extension 2',
            'generalSetting': 'Paramètre général',
            'advancedSettings': 'Paramètres avancés',
            'firstName': 'Prénom',
            'lastName': 'Nom de famille',
            'occupation': 'Occupation',
            'phoneNo': 'Numéro de téléphone',
            'address': 'Adresse',
            'city': 'Ville',
            'state': 'Etat',
            'zipCode': 'Code postal',
            'social Connection': 'Connexion sociale',
            'emailPrefrences': 'Préférences de messagerie',
            'myProfile': 'Mon profil',
            'product': 'Produit',
            'quantity': 'Quantité',
            'totalPrice': 'Prix total',
            'removeProduct': 'Supprimer le produit',
            'mobileNumber': 'Numéro de portable',
            'address2Optional': 'Adresse 2 (facultatif)',
            'country': 'Pays',
            'zip': 'Zip *: français',
            'saveContinue': 'Enregistrer continuer',
            'placeOrder': 'Passer la commande',
            'payment': 'Paiement',
            'billingAddress': 'Adresse de facturation',
            'ShippingAddressText': 'L\'adresse de livraison est la même que l\'adresse de facturation.',
            'CartEmptyText': 'Votre panier est vide!',
            'NoItemFound': 'Aucun article trouvé',
            'goToShop': 'Aller à la boutique',
            'cardNumber': 'Numéro de carte',
            'expiryDate': 'Date d\'expiration',
            'cvv': 'CVV',
            'nameOnCard': 'Nom sur carte',
            'confirmPayment': 'Confirmer le paiement'
        },
        'compenets': {
            'choose': 'Choisir',
            'username': 'Nom d\'utilisateur',
            'passwords': 'Mots de passe',
            'signIn': 'Se connecter',
            'dontHaveAccountSignUp': 'N\'avez pas d\'inscription de compte',
            'enterUserName': 'Saisissez votre nom d\'utilisateur',
            'enterEmailAddress': 'Entrer l\'adresse e-mail',
            'confirmPasswords': 'Confirmer les mots de passe'
        },
        'themeOptions': {
            'sidebarOverlay': 'Superposition de la barre latérale',
            'sidebarBackgroundImages': 'Images de fond de la barre latérale',
            'sidebarImage': 'Image de la barre latérale',
            'miniSidebar': 'Mini barre latérale',
            'boxLayout': 'Box Layout',
            'rtlLayout': 'Rtl Layout',
            'darkMode': 'Mode sombre',
            'appSettings': 'Paramètres de l\'application',
            'sidebarLight': 'Lumière',
            'sidebarDark': 'Foncé',
            'themeColor': 'Couleur du thème'
        },
        'button': {
            'cancel': 'Annuler',
            'add': 'Ajouter',
            'update': 'Mettre à jour',
            'reply': 'Répondre',
            'delete': 'Effacer',
            'yes': 'Oui',
            'viewAll': 'Voir tout',
            'like': 'Comme',
            'assignNow': 'Assigner maintenant',
            'seeInsights': 'Voir Insights',
            'acceptTerms': 'Accepter les termes',
            'reject': 'Rejeter',
            'addNew': 'Ajouter un nouveau',
            'goToCampaign': 'Aller à la campagne',
            'viewProfile': 'Voir le profil',
            'sendMessage': 'Envoyer un message',
            'saveNow': 'Enregistrer maintenant',
            'pen': 'Stylo',
            'search': 'Rechercher',
            'downloadPdfReport': 'Télécharger le rapport Pdf',
            'primary': 'Primaire',
            'info': 'Info',
            'success': 'Succès',
            'warning': 'Avertissement',
            'link': 'Lien',
            'smallButton': 'Petit bouton',
            'largeButton': 'Grand bouton',
            'blockLevelButton': 'Bouton de niveau de bloc',
            'primaryButton': 'Bouton principal',
            'button': 'Bouton',
            'save': 'Enregistrer',
            'openMenu': 'Ouvrir le menu',
            'openWithFadeTransition': 'Ouvrir avec une transition de fondu',
            'openPopover': 'Ouvrir Popover',
            'accept': 'Accepter',
            'click': 'Cliquer',
            'complete': 'Achevée',
            'back': 'Arrière',
            'next': 'Prochain',
            'completeStep': 'Étape complète',
            'error': 'Erreur',
            'writeNewMessage': 'Ecrire un nouveau message',
            'saveChanges': 'Sauvegarder les modifications',
            'addNewUser': 'Ajouter un nouvel utilisateur',
            'more': 'Plus',
            'useDefaultImage': 'Utiliser l\'image par défaut',
            'cropImage': 'Crop Image'
        },
        'hint': {
            'whatAreYouLookingFor': 'Que recherchez-vous',
            'searchMailList': 'Rechercher une liste de courrier'
        },
        'module': {
            'inbox': 'Boîte de réception',
            'drafts': 'brouillons',
            'sent': 'Envoyé',
            'trash': 'Corbeille',
            'spam': 'Spam',
            'frontend': 'L\'extrémité avant',
            'backend': 'Backend',
            'api': 'Api',
            'issue': 'Problème'
        },
        'documents': {},
        'common': {},
        'logout': {},
        'login': {},
        'actions': {},
        'sign_up': {},
        'bouton': {
            'secondaire': 'Secondaire',
            'danger': 'Danger'
        }
    }
};
